import _ from 'lodash';

const prePlatformDataSy2014_2015 = {
  projects: [
    {
      createdAt: '2015-01-01',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2015-01-02',
      students: 54,
      network: 1,
    },
    {
      createdAt: '2015-01-06',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2015-01-10',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2015-01-10',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2015-01-12',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2015-01-14',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2015-01-14',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2015-01-18',
      students: 17,
      network: 1,
    },
    {
      createdAt: '2015-01-23',
      students: 43,
      network: 1,
    },
    {
      createdAt: '2015-01-23',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2015-01-24',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2015-01-27',
      students: 42,
      network: 1,
    },
    {
      createdAt: '2015-01-28',
      students: 30,
      network: 1,
    },
    {
      createdAt: '2015-02-02',
      students: 26,
      network: 1,
    },
    {
      createdAt: '2015-02-04',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2015-02-06',
      students: 90,
      network: 1,
    },
    {
      createdAt: '2015-02-10',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2015-02-11',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2015-03-04',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2015-03-09',
      students: 57,
      network: 1,
    },
    {
      createdAt: '2015-03-10',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2015-03-10',
      students: 22,
      network: 1,
    },
    {
      createdAt: '2015-03-16',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2015-03-20',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2015-03-22',
      students: 17,
      network: 1,
    },
    {
      createdAt: '2015-03-27',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2015-03-27',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2015-03-28',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2015-03-29',
      students: 50,
      network: 1,
    },
    {
      createdAt: '2015-04-07',
      students: 29,
      network: 1,
    },
    {
      createdAt: '2015-04-08',
      students: 7,
      network: 1,
    },
    {
      createdAt: '2015-04-15',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2015-04-21',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2015-04-22',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2015-04-25',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2015-05-01',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2015-05-03',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2015-05-18',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2015-05-24',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2015-05-24',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2015-05-27',
      students: 13,
      network: 1,
    },
  ]
}
const prePlatformDataSy2015_2016 = {
  projects: [
    {
      createdAt: '2015-08-01',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2015-08-04',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2015-08-07',
      students: 95,
      network: 1,
    },
    {
      createdAt: '2015-08-11',
      students: 19,
      network: 1,
    },
    {
      createdAt: '2015-08-19',
      students: 53,
      network: 1,
    },
    {
      createdAt: '2015-08-20',
      students: 38,
      network: 1,
    },
    {
      createdAt: '2015-08-23',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2015-08-27',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2015-08-27',
      students: 29,
      network: 1,
    },
    {
      createdAt: '2015-09-05',
      students: 30,
      network: 1,
    },
    {
      createdAt: '2015-09-14',
      students: 96,
      network: 1,
    },
    {
      createdAt: '2015-09-14',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2015-09-17',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2015-09-22',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2015-09-25',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2015-10-04',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2015-10-09',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2015-10-12',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2015-10-21',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2015-10-23',
      students: 21,
      network: 1,
    },
    {
      createdAt: '2015-11-14',
      students: 29,
      network: 1,
    },
    {
      createdAt: '2015-12-04',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2015-12-14',
      students: 82,
      network: 1,
    },
    {
      createdAt: '2015-12-15',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2015-12-16',
      students: 39,
      network: 1,
    },
    {
      createdAt: '2015-12-28',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2016-01-04',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2016-01-09',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2016-01-09',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2016-01-18',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2016-01-18',
      students: 7,
      network: 1,
    },
    {
      createdAt: '2016-01-20',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2016-01-22',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2016-01-23',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2016-02-10',
      students: 46,
      network: 1,
    },
    {
      createdAt: '2016-02-11',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2016-02-20',
      students: 21,
      network: 1,
    },
    {
      createdAt: '2016-02-25',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2016-03-08',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2016-03-11',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2016-03-17',
      students: 28,
      network: 1,
    },
    {
      createdAt: '2016-03-28',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2016-04-01',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2016-04-04',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2016-04-24',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2016-04-26',
      students: 59,
      network: 1,
    },
    {
      createdAt: '2016-05-01',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2016-05-14',
      students: 30,
      network: 1,
    },
    {
      createdAt: '2016-05-14',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2016-05-16',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2016-05-20',
      students: 15,
      network: 1,
    },
  ]
}
const prePlatformDataSy2016_2017 = {
  projects: [
    {
      createdAt: '2016-08-01',
      students: 19,
      network: 1,
    },
    {
      createdAt: '2016-08-04',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2016-08-07',
      students: 86,
      network: 1,
    },
    {
      createdAt: '2016-08-11',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2016-08-19',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2016-08-20',
      students: 21,
      network: 1,
    },
    {
      createdAt: '2016-08-23',
      students: 96,
      network: 1,
    },
    {
      createdAt: '2016-08-27',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2016-08-27',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2016-09-05',
      students: 38,
      network: 1,
    },
    {
      createdAt: '2016-09-14',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2016-09-14',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2016-09-17',
      students: 74,
      network: 1,
    },
    {
      createdAt: '2016-09-22',
      students: 95,
      network: 1,
    },
    {
      createdAt: '2016-09-25',
      students: 48,
      network: 1,
    },
    {
      createdAt: '2016-10-04',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2016-10-09',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2016-10-12',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2016-10-21',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2016-10-23',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2016-11-14',
      students: 28,
      network: 1,
    },
    {
      createdAt: '2016-12-04',
      students: 39,
      network: 1,
    },
    {
      createdAt: '2016-12-14',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2016-12-15',
      students: 29,
      network: 1,
    },
    {
      createdAt: '2016-12-16',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2016-12-28',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2017-01-04',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2017-01-09',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2017-01-09',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2017-01-18',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2017-01-18',
      students: 45,
      network: 1,
    },
    {
      createdAt: '2017-01-20',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2017-01-22',
      students: 55,
      network: 1,
    },
    {
      createdAt: '2017-01-23',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2017-02-10',
      students: 7,
      network: 1,
    },
    {
      createdAt: '2017-02-11',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2017-02-20',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2017-02-25',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2017-03-03',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2017-03-09',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2017-03-11',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2017-03-12',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2017-03-18',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2017-03-29',
      students: 59,
      network: 1,
    },
    {
      createdAt: '2017-04-02',
      students: 26,
      network: 1,
    },
    {
      createdAt: '2017-04-05',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2017-04-06',
      students: 21,
      network: 1,
    },
    {
      createdAt: '2017-04-20',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2017-04-24',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2017-04-25',
      students: 33,
      network: 1,
    },
    {
      createdAt: '2017-04-27',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2017-05-02',
      students: 22,
      network: 1,
    },
    {
      createdAt: '2017-05-03',
      students: 46,
      network: 1,
    },
    {
      createdAt: '2017-05-15',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2017-05-15',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2017-05-17',
      students: 30,
      network: 1,
    },
    {
      createdAt: '2017-05-21',
      students: 7,
      network: 1,
    },
  ]
}
const prePlatformDataSy2017_2018 = {
  projects: [
    {
      createdAt: '2017-08-01',
      students: 154,
      network: 1,
    },
    {
      createdAt: '2017-08-05',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2017-08-18',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2017-08-20',
      students: 187,
      network: 1,
    },
    {
      createdAt: '2017-08-25',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2017-08-25',
      students: 31,
      network: 1,
    },
    {
      createdAt: '2017-08-27',
      students: 38,
      network: 1,
    },
    {
      createdAt: '2017-08-29',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2017-08-30',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2017-08-31',
      students: 88,
      network: 1,
    },
    {
      createdAt: '2017-09-05',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2017-09-05',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2017-09-09',
      students: 188,
      network: 1,
    },
    {
      createdAt: '2017-09-14',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2017-09-15',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2017-09-20',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2017-09-25',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2017-10-06',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2017-10-09',
      students: 29,
      network: 1,
    },
    {
      createdAt: '2017-10-11',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2017-10-12',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2017-10-13',
      students: 38,
      network: 1,
    },
    {
      createdAt: '2017-10-20',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2017-10-23',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2017-10-28',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2017-10-31',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2017-11-01',
      students: 98,
      network: 1,
    },
    {
      createdAt: '2017-11-04',
      students: 67,
      network: 1,
    },
    {
      createdAt: '2017-11-08',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2017-11-14',
      students: 36,
      network: 1,
    },
    {
      createdAt: '2017-11-24',
      students: 85,
      network: 1,
    },
    {
      createdAt: '2017-11-25',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2017-11-30',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2017-12-10',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2017-12-20',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2017-12-21',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2017-12-24',
      students: 43,
      network: 1,
    },
    {
      createdAt: '2017-12-24',
      students: 77,
      network: 1,
    },
    {
      createdAt: '2018-01-03',
      students: 44,
      network: 1,
    },
    {
      createdAt: '2018-01-04',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2018-01-04',
      students: 26,
      network: 1,
    },
    {
      createdAt: '2018-01-17',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2018-01-19',
      students: 99,
      network: 1,
    },
    {
      createdAt: '2018-01-24',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2018-01-25',
      students: 35,
      network: 1,
    },
    {
      createdAt: '2018-01-27',
      students: 30,
      network: 1,
    },
    {
      createdAt: '2018-01-28',
      students: 26,
      network: 1,
    },
    {
      createdAt: '2018-01-29',
      students: 19,
      network: 1,
    },
    {
      createdAt: '2018-01-29',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2018-01-31',
      students: 22,
      network: 1,
    },
    {
      createdAt: '2018-02-02',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2018-02-12',
      students: 22,
      network: 1,
    },
    {
      createdAt: '2018-02-13',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2018-02-16',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2018-02-18',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2018-02-20',
      students: 43,
      network: 1,
    },
    {
      createdAt: '2018-02-20',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2018-02-24',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2018-03-12',
      students: 69,
      network: 1,
    },
    {
      createdAt: '2018-03-16',
      students: 103,
      network: 1,
    },
    {
      createdAt: '2018-03-19',
      students: 116,
      network: 1,
    },
    {
      createdAt: '2018-03-20',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2018-03-29',
      students: 51,
      network: 1,
    },
    {
      createdAt: '2018-03-31',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2018-04-01',
      students: 94,
      network: 1,
    },
    {
      createdAt: '2018-04-02',
      students: 97,
      network: 1,
    },
    {
      createdAt: '2018-04-06',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2018-04-21',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2018-04-25',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2018-04-27',
      students: 73,
      network: 1,
    },
    {
      createdAt: '2018-05-05',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2018-05-07',
      students: 72,
      network: 1,
    },
    {
      createdAt: '2018-05-25',
      students: 31,
      network: 1,
    },
    {
      createdAt: '2018-05-26',
      students: 42,
      network: 1,
    },
    {
      createdAt: '2018-05-27',
      students: 31,
      network: 1,
    },
    {
      createdAt: '2018-05-29',
      students: 67,
      network: 1,
    },
  ]
}
const prePlatformDataSy2018_2019 = {
  projects: [
    {
      createdAt: '2018-08-01',
      students: 35,
      network: 1,
    },
    {
      createdAt: '2018-08-01',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2018-08-04',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2018-08-05',
      students: 58,
      network: 1,
    },
    {
      createdAt: '2018-08-06',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2018-08-07',
      students: 41,
      network: 1,
    },
    {
      createdAt: '2018-08-07',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2018-08-09',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2018-08-11',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2018-08-11',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2018-08-15',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2018-08-17',
      students: 51,
      network: 1,
    },
    {
      createdAt: '2018-08-19',
      students: 49,
      network: 1,
    },
    {
      createdAt: '2018-08-20',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2018-08-23',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2018-08-23',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2018-08-27',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2018-08-27',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2018-08-31',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2018-09-02',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2018-09-05',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2018-09-07',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2018-09-07',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2018-09-12',
      students: 95,
      network: 1,
    },
    {
      createdAt: '2018-09-12',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2018-09-14',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2018-09-14',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2018-09-15',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2018-09-15',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2018-09-17',
      students: 46,
      network: 1,
    },
    {
      createdAt: '2018-09-22',
      students: 65,
      network: 1,
    },
    {
      createdAt: '2018-09-25',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2018-09-25',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2018-10-04',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2018-10-08',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2018-10-09',
      students: 63,
      network: 1,
    },
    {
      createdAt: '2018-10-12',
      students: 51,
      network: 1,
    },
    {
      createdAt: '2018-10-18',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2018-10-21',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2018-10-23',
      students: 52,
      network: 1,
    },
    {
      createdAt: '2018-10-27',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2018-10-30',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2018-11-01',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2018-11-05',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2018-11-07',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2018-11-14',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2018-11-26',
      students: 21,
      network: 1,
    },
    {
      createdAt: '2018-11-28',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2018-12-04',
      students: 60,
      network: 1,
    },
    {
      createdAt: '2018-12-10',
      students: 73,
      network: 1,
    },
    {
      createdAt: '2018-12-13',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2018-12-13',
      students: 22,
      network: 1,
    },
    {
      createdAt: '2018-12-14',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2018-12-15',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2018-12-16',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2018-12-18',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2018-12-26',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2018-12-28',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2019-01-04',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2019-01-09',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2019-01-09',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2019-01-13',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2019-01-18',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2019-01-18',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2019-01-19',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2019-01-20',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2019-01-20',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2019-01-20',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2019-01-22',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2019-01-23',
      students: 69,
      network: 1,
    },
    {
      createdAt: '2019-01-28',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2019-01-28',
      students: 41,
      network: 1,
    },
    {
      createdAt: '2019-01-29',
      students: 86,
      network: 1,
    },
    {
      createdAt: '2019-02-03',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2019-02-08',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2019-02-10',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2019-02-10',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2019-02-10',
      students: 79,
      network: 1,
    },
    {
      createdAt: '2019-02-11',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2019-02-15',
      students: 7,
      network: 1,
    },
    {
      createdAt: '2019-02-17',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2019-02-20',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2019-02-23',
      students: 50,
      network: 1,
    },
    {
      createdAt: '2019-02-24',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2019-02-25',
      students: 112,
      network: 1,
    },
    {
      createdAt: '2019-03-03',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2019-03-04',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2019-03-09',
      students: 46,
      network: 1,
    },
    {
      createdAt: '2019-03-10',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2019-03-11',
      students: 17,
      network: 1,
    },
    {
      createdAt: '2019-03-11',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2019-03-12',
      students: 72,
      network: 1,
    },
    {
      createdAt: '2019-03-16',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2019-03-18',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2019-03-22',
      students: 22,
      network: 1,
    },
    {
      createdAt: '2019-03-22',
      students: 31,
      network: 1,
    },
    {
      createdAt: '2019-03-25',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2019-03-29',
      students: 33,
      network: 1,
    },
    {
      createdAt: '2019-03-30',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2019-04-02',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2019-04-05',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2019-04-05',
      students: 38,
      network: 1,
    },
    {
      createdAt: '2019-04-06',
      students: 44,
      network: 1,
    },
    {
      createdAt: '2019-04-07',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2019-04-11',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2019-04-14',
      students: 28,
      network: 1,
    },
    {
      createdAt: '2019-04-19',
      students: 45,
      network: 1,
    },
    {
      createdAt: '2019-04-19',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2019-04-20',
      students: 58,
      network: 1,
    },
    {
      createdAt: '2019-04-24',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2019-04-25',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2019-04-27',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2019-04-30',
      students: 41,
      network: 1,
    },
    {
      createdAt: '2019-05-02',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2019-05-02',
      students: 21,
      network: 1,
    },
    {
      createdAt: '2019-05-02',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2019-05-03',
      students: 19,
      network: 1,
    },
    {
      createdAt: '2019-05-06',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2019-05-07',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2019-05-11',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2019-05-15',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2019-05-15',
      students: 19,
      network: 1,
    },
    {
      createdAt: '2019-05-17',
      students: 37,
      network: 1,
    },
    {
      createdAt: '2019-05-21',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2019-05-21',
      students: 52,
      network: 1,
    },
    {
      createdAt: '2019-05-28',
      students: 56,
      network: 1,
    },
  ]
}
const prePlatformDataSy2019_2020 = {
  projects: [
    {
      createdAt: '2019-08-01',
      students: 7,
      network: 1,
    },
    {
      createdAt: '2019-08-04',
      students: 40,
      network: 1,
    },
    {
      createdAt: '2019-08-11',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2019-08-20',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2019-08-23',
      students: 30,
      network: 1,
    },
    {
      createdAt: '2019-08-27',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2019-08-27',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2019-09-05',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2019-09-14',
      students: 88,
      network: 1,
    },
    {
      createdAt: '2019-09-14',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2019-09-17',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2019-09-22',
      students: 33,
      network: 1,
    },
    {
      createdAt: '2019-09-25',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2019-10-04',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2019-10-09',
      students: 17,
      network: 1,
    },
    {
      createdAt: '2019-10-12',
      students: 54,
      network: 1,
    },
    {
      createdAt: '2019-10-21',
      students: 36,
      network: 1,
    },
    {
      createdAt: '2019-10-23',
      students: 168,
      network: 1,
    },
    {
      createdAt: '2019-12-04',
      students: 26,
      network: 1,
    },
    {
      createdAt: '2019-12-14',
      students: 19,
      network: 1,
    },
    {
      createdAt: '2019-12-15',
      students: 21,
      network: 1,
    },
    {
      createdAt: '2019-12-16',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2019-12-28',
      students: 25,
      network: 1,
    },
    {
      createdAt: '2020-01-09',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2020-01-18',
      students: 46,
      network: 1,
    },
    {
      createdAt: '2020-01-18',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2020-01-20',
      students: 113,
      network: 1,
    },
    {
      createdAt: '2020-01-22',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2020-02-10',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2020-02-11',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2020-02-25',
      students: 75,
      network: 1,
    },
    {
      createdAt: '2020-03-08',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2020-03-11',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2020-03-17',
      students: 47,
      network: 1,
    },
    {
      createdAt: '2020-03-28',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2020-04-01',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2020-05-01',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2020-05-14',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2020-05-14',
      students: 44,
      network: 1,
    },
    {
      createdAt: '2020-05-20',
      students: 21,
      network: 1,
    },
  ]

}
const prePlatformDataSy2020_2021_Pima = {
  projects: [
    {
      createdAt: '2020-08-02',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2020-08-07',
      students: 7,
      network: 1,
    },
    {
      createdAt: '2020-08-11',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2020-09-09',
      students: 19,
      network: 1,
    },
    {
      createdAt: '2020-09-21',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2020-09-28',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2020-09-30',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2020-10-09',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2020-10-09',
      students: 45,
      network: 1,
    },
    {
      createdAt: '2020-10-22',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2020-10-23',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2020-10-28',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2020-10-31',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2020-11-15',
      students: 10,
      network: 1,
    },
    {
      createdAt: '2020-11-17',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2020-12-12',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2020-12-21',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2020-12-27',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2021-01-01',
      students: 24,
      network: 1,
    },
    {
      createdAt: '2021-01-06',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2021-01-12',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2021-01-23',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2021-01-31',
      students: 7,
      network: 1,
    },
    {
      createdAt: '2021-02-05',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2021-02-17',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2021-03-03',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2021-03-09',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2021-03-10',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2021-03-12',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2021-03-14',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2021-03-29',
      students: 12,
      network: 1,
    },
    {
      createdAt: '2021-04-10',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2021-04-12',
      students: 31,
      network: 1,
    },
    {
      createdAt: '2021-04-23',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2021-04-27',
      students: 0,
      network: 1,
    },
    {
      createdAt: '2021-05-02',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2021-05-18',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2021-05-24',
      students: 14,
      network: 1,
    },
  ]


}
const prePlatformDataSy2020_2021_LasCruces = {
  projects: [
    {
      createdAt: '2020-08-13',
      students: 2,
      network: 2,
    },
    {
      createdAt: '2020-08-23',
      students: 11,
      network: 2,
    },
    {
      createdAt: '2020-08-28',
      students: 3,
      network: 2,
    },
    {
      createdAt: '2020-08-30',
      students: 2,
      network: 2,
    },
    {
      createdAt: '2020-09-05',
      students: 0,
      network: 2,
    },
    {
      createdAt: '2020-09-09',
      students: 5,
      network: 2,
    },
    {
      createdAt: '2020-09-22',
      students: 27,
      network: 2,
    },
    {
      createdAt: '2020-09-24',
      students: 49,
      network: 2,
    },
    {
      createdAt: '2020-09-25',
      students: 1,
      network: 2,
    },
    {
      createdAt: '2020-10-09',
      students: 3,
      network: 2,
    },
    {
      createdAt: '2020-10-22',
      students: 5,
      network: 2,
    },
    {
      createdAt: '2020-10-25',
      students: 8,
      network: 2,
    },
    {
      createdAt: '2020-10-31',
      students: 2,
      network: 2,
    },
    {
      createdAt: '2020-11-17',
      students: 8,
      network: 2,
    },
    {
      createdAt: '2020-11-18',
      students: 13,
      network: 2,
    },
    {
      createdAt: '2020-11-18',
      students: 7,
      network: 2,
    },
    {
      createdAt: '2020-11-30',
      students: 48,
      network: 2,
    },
    {
      createdAt: '2020-12-10',
      students: 5,
      network: 2,
    },
    {
      createdAt: '2020-12-11',
      students: 6,
      network: 2,
    },
    {
      createdAt: '2021-01-05',
      students: 0,
      network: 2,
    },
    {
      createdAt: '2021-01-05',
      students: 0,
      network: 2,
    },
    {
      createdAt: '2021-01-09',
      students: 12,
      network: 2,
    },
    {
      createdAt: '2021-01-15',
      students: 1,
      network: 2,
    },
    {
      createdAt: '2021-02-02',
      students: 7,
      network: 2,
    },
    {
      createdAt: '2021-02-07',
      students: 2,
      network: 2,
    },
    {
      createdAt: '2021-03-08',
      students: 4,
      network: 2,
    },
    {
      createdAt: '2021-03-19',
      students: 5,
      network: 2,
    },
    {
      createdAt: '2021-03-21',
      students: 5,
      network: 2,
    },
    {
      createdAt: '2021-03-29',
      students: 7,
      network: 2,
    },
    {
      createdAt: '2021-03-31',
      students: 6,
      network: 2,
    },
    {
      createdAt: '2021-04-11',
      students: 1,
      network: 2,
    },
    {
      createdAt: '2021-04-30',
      students: 5,
      network: 2,
    },
    {
      createdAt: '2021-05-03',
      students: 0,
      network: 2,
    },
    {
      createdAt: '2021-05-07',
      students: 9,
      network: 2,
    },
    {
      createdAt: '2021-05-09',
      students: 16,
      network: 2,
    },
    {
      createdAt: '2021-05-09',
      students: 7,
      network: 2,
    },
    {
      createdAt: '2021-05-21',
      students: 4,
      network: 2,
    },
    {
      createdAt: '2021-05-31',
      students: 28,
      network: 2,
    },
  ]
}
const prePlatformDataSy2021_2022_Pima = {
  projects: [
    {
      createdAt: '2021-08-05',
      students: 34,
      network: 1,
    },
    {
      createdAt: '2021-08-06',
      students: 40,
      network: 1,
    },
    {
      createdAt: '2021-08-10',
      students: 124,
      network: 1,
    },
    {
      createdAt: '2021-08-23',
      students: 45,
      network: 1,
    },
    {
      createdAt: '2021-08-27',
      students: 35,
      network: 1,
    },
    {
      createdAt: '2021-09-02',
      students: 37,
      network: 1,
    },
    {
      createdAt: '2021-09-04',
      students: 94,
      network: 1,
    },
    {
      createdAt: '2021-09-10',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2021-09-13',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2021-09-14',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2021-09-26',
      students: 71,
      network: 1,
    },
    {
      createdAt: '2021-09-27',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2021-10-08',
      students: 40,
      network: 1,
    },
    {
      createdAt: '2021-10-16',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2021-10-19',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2021-10-20',
      students: 6,
      network: 1,
    },
    {
      createdAt: '2021-10-22',
      students: 18,
      network: 1,
    },
    {
      createdAt: '2021-10-25',
      students: 52,
      network: 1,
    },
    {
      createdAt: '2021-10-26',
      students: 61,
      network: 1,
    },
    {
      createdAt: '2021-10-30',
      students: 75,
      network: 1,
    },
    {
      createdAt: '2021-11-03',
      students: 27,
      network: 1,
    },
    {
      createdAt: '2021-11-04',
      students: 40,
      network: 1,
    },
    {
      createdAt: '2021-11-05',
      students: 55,
      network: 1,
    },
    {
      createdAt: '2021-11-10',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2021-11-17',
      students: 119,
      network: 1,
    },
    {
      createdAt: '2021-11-23',
      students: 171,
      network: 1,
    },
    {
      createdAt: '2021-11-26',
      students: 7,
      network: 1,
    },
    {
      createdAt: '2021-11-27',
      students: 114,
      network: 1,
    },
    {
      createdAt: '2021-11-29',
      students: 49,
      network: 1,
    },
    {
      createdAt: '2021-12-01',
      students: 52,
      network: 1,
    },
    {
      createdAt: '2021-12-02',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2021-12-02',
      students: 166,
      network: 1,
    },
    {
      createdAt: '2021-12-04',
      students: 124,
      network: 1,
    },
    {
      createdAt: '2021-12-07',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2021-12-14',
      students: 52,
      network: 1,
    },
    {
      createdAt: '2021-12-20',
      students: 54,
      network: 1,
    },
    {
      createdAt: '2021-12-21',
      students: 59,
      network: 1,
    },
    {
      createdAt: '2021-12-21',
      students: 28,
      network: 1,
    },
    {
      createdAt: '2021-12-22',
      students: 133,
      network: 1,
    },
    {
      createdAt: '2021-12-22',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2021-12-23',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2021-12-24',
      students: 70,
      network: 1,
    },
    {
      createdAt: '2021-12-24',
      students: 42,
      network: 1,
    },
    {
      createdAt: '2021-12-31',
      students: 63,
      network: 1,
    },
    {
      createdAt: '2022-01-03',
      students: 37,
      network: 1,
    },
    {
      createdAt: '2022-01-04',
      students: 180,
      network: 1,
    },
    {
      createdAt: '2022-01-05',
      students: 5,
      network: 1,
    },
    {
      createdAt: '2022-01-07',
      students: 52,
      network: 1,
    },
    {
      createdAt: '2022-01-07',
      students: 40,
      network: 1,
    },
    {
      createdAt: '2022-01-09',
      students: 43,
      network: 1,
    },
    {
      createdAt: '2022-01-10',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2022-01-22',
      students: 118,
      network: 1,
    },
    {
      createdAt: '2022-01-26',
      students: 43,
      network: 1,
    },
    {
      createdAt: '2022-01-28',
      students: 86,
      network: 1,
    },
    {
      createdAt: '2022-01-29',
      students: 14,
      network: 1,
    },
    {
      createdAt: '2022-01-30',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2022-02-01',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2022-02-01',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2022-02-04',
      students: 57,
      network: 1,
    },
    {
      createdAt: '2022-02-06',
      students: 38,
      network: 1,
    },
    {
      createdAt: '2022-02-06',
      students: 26,
      network: 1,
    },
    {
      createdAt: '2022-02-07',
      students: 78,
      network: 1,
    },
    {
      createdAt: '2022-02-07',
      students: 13,
      network: 1,
    },
    {
      createdAt: '2022-02-09',
      students: 15,
      network: 1,
    },
    {
      createdAt: '2022-02-12',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2022-02-15',
      students: 46,
      network: 1,
    },
    {
      createdAt: '2022-02-16',
      students: 44,
      network: 1,
    },
    {
      createdAt: '2022-02-19',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2022-02-24',
      students: 29,
      network: 1,
    },
    {
      createdAt: '2022-02-28',
      students: 17,
      network: 1,
    },
    {
      createdAt: '2022-03-01',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2022-03-07',
      students: 38,
      network: 1,
    },
    {
      createdAt: '2022-03-09',
      students: 31,
      network: 1,
    },
    {
      createdAt: '2022-03-11',
      students: 11,
      network: 1,
    },
    {
      createdAt: '2022-03-11',
      students: 87,
      network: 1,
    },
    {
      createdAt: '2022-03-11',
      students: 57,
      network: 1,
    },
    {
      createdAt: '2022-03-12',
      students: 1,
      network: 1,
    },
    {
      createdAt: '2022-03-12',
      students: 132,
      network: 1,
    },
    {
      createdAt: '2022-03-15',
      students: 2,
      network: 1,
    },
    {
      createdAt: '2022-03-18',
      students: 3,
      network: 1,
    },
    {
      createdAt: '2022-03-19',
      students: 162,
      network: 1,
    },
    {
      createdAt: '2022-03-22',
      students: 4,
      network: 1,
    },
    {
      createdAt: '2022-03-23',
      students: 20,
      network: 1,
    },
    {
      createdAt: '2022-03-23',
      students: 23,
      network: 1,
    },
    {
      createdAt: '2022-03-25',
      students: 48,
      network: 1,
    },
    {
      createdAt: '2022-03-26',
      students: 9,
      network: 1,
    },
    {
      createdAt: '2022-04-07',
      students: 68,
      network: 1,
    },
    {
      createdAt: '2022-04-09',
      students: 37,
      network: 1,
    },
    {
      createdAt: '2022-04-13',
      students: 66,
      network: 1,
    },
    {
      createdAt: '2022-04-14',
      students: 22,
      network: 1,
    },
    {
      createdAt: '2022-04-16',
      students: 54,
      network: 1,
    },
    {
      createdAt: '2022-04-20',
      students: 33,
      network: 1,
    },
    {
      createdAt: '2022-04-25',
      students: 137,
      network: 1,
    },
    {
      createdAt: '2022-04-30',
      students: 238,
      network: 1,
    },
    {
      createdAt: '2022-05-02',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2022-05-10',
      students: 19,
      network: 1,
    },
    {
      createdAt: '2022-05-21',
      students: 8,
      network: 1,
    },
    {
      createdAt: '2022-05-29',
      students: 32,
      network: 1,
    },
    {
      createdAt: '2022-05-29',
      students: 16,
      network: 1,
    },
    {
      createdAt: '2022-06-01',
      students: 41,
      network: 1,
    },
  ]
}
const prePlatformDataSy2021_2022_LasCruces = {
  projects: [
    {
      createdAt: '2021-08-05',
      students: 39,
      network: 2,
    },
    {
      createdAt: '2021-08-08',
      students: 12,
      network: 2,
    },
    {
      createdAt: '2021-08-24',
      students: 0,
      network: 2,
    },
    {
      createdAt: '2021-09-06',
      students: 4,
      network: 2,
    },
    {
      createdAt: '2021-09-09',
      students: 47,
      network: 2,
    },
    {
      createdAt: '2021-09-10',
      students: 13,
      network: 2,
    },
    {
      createdAt: '2021-09-14',
      students: 10,
      network: 2,
    },
    {
      createdAt: '2021-09-16',
      students: 15,
      network: 2,
    },
    {
      createdAt: '2021-09-17',
      students: 32,
      network: 2,
    },
    {
      createdAt: '2021-09-17',
      students: 10,
      network: 2,
    },
    {
      createdAt: '2021-09-17',
      students: 12,
      network: 2,
    },
    {
      createdAt: '2021-09-21',
      students: 38,
      network: 2,
    },
    {
      createdAt: '2021-09-22',
      students: 3,
      network: 2,
    },
    {
      createdAt: '2021-09-26',
      students: 17,
      network: 2,
    },
    {
      createdAt: '2021-09-28',
      students: 6,
      network: 2,
    },
    {
      createdAt: '2021-10-06',
      students: 18,
      network: 2,
    },
    {
      createdAt: '2021-10-07',
      students: 16,
      network: 2,
    },
    {
      createdAt: '2021-10-14',
      students: 22,
      network: 2,
    },
    {
      createdAt: '2021-11-16',
      students: 82,
      network: 2,
    },
    {
      createdAt: '2021-11-16',
      students: 121,
      network: 2,
    },
    {
      createdAt: '2021-12-26',
      students: 1,
      network: 2,
    },
    {
      createdAt: '2021-12-28',
      students: 37,
      network: 2,
    },
    {
      createdAt: '2022-01-04',
      students: 26,
      network: 2,
    },
    {
      createdAt: '2022-02-10',
      students: 25,
      network: 2,
    },
    {
      createdAt: '2022-02-13',
      students: 13,
      network: 2,
    },
    {
      createdAt: '2022-02-27',
      students: 15,
      network: 2,
    },
    {
      createdAt: '2022-02-27',
      students: 39,
      network: 2,
    },
    {
      createdAt: '2022-03-19',
      students: 20,
      network: 2,
    },
    {
      createdAt: '2022-04-01',
      students: 39,
      network: 2,
    },
    {
      createdAt: '2022-04-08',
      students: 30,
      network: 2,
    },
    {
      createdAt: '2022-04-19',
      students: 37,
      network: 2,
    },
    {
      createdAt: '2022-04-20',
      students: 57,
      network: 2,
    },
    {
      createdAt: '2022-05-04',
      students: 37,
      network: 2,
    },
    {
      createdAt: '2022-05-05',
      students: 22,
      network: 2,
    },
    {
      createdAt: '2022-05-19',
      students: 30,
      network: 2,
    },
    {
      createdAt: '2022-05-26',
      students: 42,
      network: 2,
    },
    {
      createdAt: '2022-05-28',
      students: 27,
      network: 2,
    },
  ]
}

const prePlatformData = {
  projects: [
    ...prePlatformDataSy2014_2015.projects,
    ...prePlatformDataSy2015_2016.projects,
    ...prePlatformDataSy2016_2017.projects,
    ...prePlatformDataSy2017_2018.projects,
    ...prePlatformDataSy2018_2019.projects,
    ...prePlatformDataSy2019_2020.projects,
    ...prePlatformDataSy2020_2021_Pima.projects,
    ...prePlatformDataSy2020_2021_LasCruces.projects,
    ...prePlatformDataSy2021_2022_Pima.projects,
    ...prePlatformDataSy2021_2022_LasCruces.projects,
  ]
}

export default function usePrePlatformProjectImpact(network, start, end) {
  const prePlatformProjects = _.filter(prePlatformData.projects, function(project) {
    return (!start || project.createdAt >= start) &&
      (!end || project.createdAt <= end) &&
      (!network || project.network === network?.id);
  });

  return _.sumBy(prePlatformProjects, 'students');
}
